import React from "react";
import Avatar from "../../../../../avatar/Avatar";
import { Tooltip } from "@mui/material";
import {
  ContentTooltipMarkingInfo,
  ContentTooltiptStudentMarkingInfo,
  useStyles,
} from "../ContentTooltip/ContentTooltip";

export const DetailMarking = ({ id, logs = [], completed, minMarking, isBulk }) => {
  const classes = useStyles();
  const list = logs
    .filter(
      (log) =>
        log.exists &&
        log.marking !== minMarking &&
        log.definition &&
        log.markingIsMaxLevel
    )
    .filter((log) =>
      isBulk ? 
        "completedTeacher"
      :
      completed === "general"
        ? true
        : completed === "completedTeacher"
        ? log.markingType === "completedStudent"
        : log.markingType === "completedTeacher"
    );

  const limit = 3;
  const shortList = list.slice(0, limit);
  const restList = list.slice(limit - 1, list.length);
  const listShort =
    restList.length > 1
      ? [
          ...shortList.slice(0, limit - 1),
          {
            _id: "rest",
            markingBy: `+${restList.length}`,
            isRest: true,
          },
        ]
      : list;

  return (
    <div
      className={[
        "flex gap-1 w-full justify-end",
        list.length > 0 ? "pt-2" : "",
      ].join(" ")}
    >
      {listShort.map((log, index) =>
        log.isRest ? (
          <Tooltip
            id={`tooltip-detail-${id}-${log._id}-${index}`}
            key={`tooltip-detail-${id}-${log._id}-${index}`}
            arrow
            placement="top"
            title={
              <div className="flex flex-wrap gap-2 justify-center items-center">
                
                {restList.map((item, index) => (
                  <div
                    key={`tooltip-detail-${id}-${log._id}-${index}`}
                    className={[
                      restList.length > 1 ? "bg-loading rounded min-w-200px max-w-200px p-2" : "",
                    ]}
                  >
                    <ContentTooltiptStudentMarkingInfo
                      marking={item}
                      student={item.student}
                    />
                  </div>
                ))}
              </div>
            }
            classes={{ tooltip: classes.customWidth2 }}
          >
            <span
              className={classes.info}
              style={{ color: "var(--muted-foreground)" }}
            >
              <Avatar
                alt={log.markingBy}
                src={`photos/${log.markingByPhoto}`}
                size={"xsmall"}
                showCompleteAlt={true}
                style={{
                  border: `3px solid #bdbdbd`,
                  color: "var(--muted-foreground)",
                }}
              />
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            id={`tooltip-detail-${id}-${log._id}-${index}`}
            key={`tooltip-detail-${id}-${log._id}-${index}`}
            arrow
            placement="top"
            title={
              log.isBulk ? (
                <ContentTooltiptStudentMarkingInfo
                  marking={log}
                  student={log.student}
                />
              ) : (
                <div className="py-1">
                  <ContentTooltipMarkingInfo
                    marking={log}
                  />
                </div>
              )
            }
            classes={{ tooltip: classes.customWidth }}
          >
            <span
              className={classes.info}
              style={{ color: log.markingSecondaryColor }}
            >
              
              <Avatar
                alt={log.isBulk ? log?.student?.code : log.markingByCode}
                src={`photos/${
                  log.isBulk ? log?.student?.photo : log.markingByPhoto
                }`}
                size={"xsmall"}
                style={{
                  border: `3px solid ${log.markingSecondaryColor}`,
                }}
              />
            </span>
          </Tooltip>
        )
      )}
    </div>
  );
};
